import {NEW_SHARED_CDN_PATH, SUPPORTS_WEBP, USE_NEW_CDN} from "Setup/config";

export const convertImagePathToWebpPath = (path) => {
    if (USE_NEW_CDN) {
        if (SUPPORTS_WEBP && path.includes(NEW_SHARED_CDN_PATH)) {
            const icon = path.split("/").pop();
            const extension = icon.split(".").pop();

            return `${path.substring(0, path.length - icon.length)}${USE_NEW_CDN ? "webp/" : ""}${icon.substring(0, icon.length - extension.length)}webp`;
        }
    }

    return path;
}
